<script setup lang="ts">
import Button from "primevue/button";
import { Participant, Project } from "../../types/PersologOnlineTypes.ts";
import { useI18n } from "vue-i18n";
import useProfileView from "../../utils/buttons-logic/profileViewLogic.ts";
import { toRefs } from "vue";

const props = defineProps({
    project: {
        type: Object as () => Project,
        required: true,
    },
    participant: {
        type: Object as () => Participant,
        required: true,
    },
    withClasses: {
        type: String,
        default: "bg-persolog-blue",
    },
});

const { t } = useI18n();

const { participant, project } = toRefs(props);

const { languages, viewable, loading, viewPdf, items } = useProfileView(participant, project);
</script>

<template>
    <SplitButton
        v-if="items.length > 1 && (participant?.status === 'GENERATED' || participant?.status === 'NOTIFIED')"
        :disabled="!viewable"
        :model="items"
        @click="viewPdf(languages[0])"
        :pt="{ pcButton: { root: { class: withClasses } }, pcDropdown: { root: { class: withClasses } } }"
        v-tooltip.top="{ value: t('project-details.participants.tooltips.view'), showDelay: 500 }"
    >
        <i :class="loading ? 'pi pi-spin pi-spinner' : 'pi pi-eye'"></i>
    </SplitButton>
    <Button
        v-if="items.length === 1 && (participant?.status === 'GENERATED' || participant?.status === 'NOTIFIED')"
        :class="withClasses"
        :id="`profile-view_button-${participant.id}`"
        :disabled="!viewable"
        :icon="loading ? 'pi pi-spin pi-spinner' : 'pi pi-eye'"
        @click="viewPdf(languages[0])"
        v-tooltip.top="{ value: t('project-details.participants.tooltips.view'), showDelay: 500 }"
    ></Button>
</template>
